<div class="field-editor">
  <div class="field-editor-label">{{ label }}</div>
  <textarea
    nbInput fullWidth
    [rows]="4"
    [maxlength]="maxLength"
    [(ngModel)]="draft"
    [disabled]="busy"
    (ngModelChange)="onInput()"
    (keydown)="onKeydown($event)">
  </textarea>
  <div class="field-editor-footer">
    <span class="field-editor-count">{{ draft.length }} / {{ maxLength }}</span>
    <div class="field-editor-actions">
      <button nbButton ghost size="tiny" status="basic" type="button" [disabled]="busy" (click)="onCancel()">
        {{ 'cv.tailor.edit.cancel' | translate }}
      </button>
      <button nbButton size="tiny" status="primary" type="button" [disabled]="!isDirty || busy" [nbSpinner]="busy" nbSpinnerStatus="control" (click)="onSave()">
        {{ 'cv.tailor.edit.save' | translate }}
      </button>
    </div>
  </div>
</div>
